<template>
    <transition
        name="fade"
        appear
    >
        <div
            class="rounded p-10 text-light font--14 lh--18 bg--black--70 highlight-em"
            style="max-width: 436px"
        >
            <div
                v-if="html"
                v-html="text"
            />

            <div v-else>
                {{ text }}
            </div>
        </div>
    </transition>
</template>

<script>
import { useListenerManager } from "front-toolkit/plugins/ListenersPlugin"

export default {
    props: {
        text: String,
        html: Boolean,
    },

    emits: ["enter", "exit"],

    setup() {
        const { listen } = useListenerManager()
        return { listen }
    },

    mounted() {
        this._removeMouseMove = this.listen("mousemove", this.mousemove)
        // We need to asume when it's mounted the cursor is on the tooltip, once the mouse moves, it will get the real status
        this.$emit("enter")
    },

    beforeUnmount() {
        this._removeMouseMove && this._removeMouseMove()
    },

    methods: {
        mousemove(event) {
            if (this.$el.contains(event.target)) {
                this.$emit("enter")
            } else {
                this.$emit("exit")
            }
        },
    },
}
</script>
